import { gql } from '@apollo/client';

const GET_LICENSE_INFORMATION_FOR_ORGANIZATION = gql`
  query GetLicenseInformationForOrganization($organizationId: Int!) {
    licenseInformationForOrganization(organizationId: $organizationId) {
      Organization {
        OrgId
        OrgName
        PaidAssigned
        PaidTotal
        FreeAssigned
        FreeTotal
      }
      OrgUnits {
        OrgUnitId
        OrgUnitName
        PaidAssigned
        PaidTotal
        FreeAssigned
        FreeTotal
      }
    }
  }
`;

export default GET_LICENSE_INFORMATION_FOR_ORGANIZATION;
